export default {
  title: 'Aukioloajat',
  headers: {
    edit_time: 'Muokkaa aikaa',
    create_time: 'Luo aika',
  },
  labels: {
    select_all: 'Valitse kaikki',
    timezone: 'Aikavyöhyke',
  },
  fields: {
    selected_days: {
      label: 'Valitut päivät',
    },
    opening_time: {
      label: 'Avausaika',
    },
    closing_time: {
      label: 'Sulkemisaika',
    },
  },
  columns: {
    days: 'Päivät',
    time: 'Aika',
  },
  buttons: {
    add_opening_time: 'Lisää aukioloaika',
    add: 'Lisää',
    cancel: 'Peruuta',
    save: 'Tallenna',
    close: 'Sulje',
    delete: 'Poista',
    sync_from_online_shop: 'Synkronoi verkkokaupasta',
  },
  projects: {
    online_shop: 'Verkkokauppa',
    reservations: 'Varaukset',
    storefront: 'Storefront',
    not_set_up: '{{project}} (ei määritetty tälle sijainnille)',
  },
  feedback: {
    missing_info: 'Puuttuvat tiedot',
  },
  toasts: {
    saving_success: 'Tallennus onnistui',
    saving_error: 'Tallennus epäonnistui. Tarkista tietosi ja yritä uudelleen.',
    sync_success: 'Synkronointi onnistui',
    sync_error: 'Aukioloaikojen synkronointi verkkokaupasta epäonnistui. Yritä uudelleen.',
    hours_required: 'Aukioloajat ovat pakollisia. Muokkaa olemassa olevia aikoja sen sijaan',
    not_copied: {
      reservations: {
        not_set_up:
          'Varauksia ei päivitetty: varauksia ei ole vielä määritetty tälle sijainnille. Varaukset-välilehti selittää miksi.',
        not_matched:
          'Varauksia ei päivitetty: niiden ajat eivät sisällä avausaikaa {{time}}. Tarkista ne Varaukset-välilehdellä.',
        failed: 'Varauksia ei voitu päivittää. Käytä ”Synkronoi verkkokaupasta” -toimintoa Varaukset-välilehdellä.',
      },
      storefront: {
        not_set_up: 'Storefrontia ei päivitetty: tälle sijainnille ei löytynyt Storefrontia.',
        not_matched:
          'Storefrontia ei päivitetty: sen ajat eivät sisällä avausaikaa {{time}}. Tarkista ne Storefront-välilehdellä.',
        failed: 'Storefrontia ei voitu päivittää. Käytä ”Synkronoi verkkokaupasta” -toimintoa Storefront-välilehdellä.',
      },
    },
  },
  modals: {
    timezone: {
      form: {
        timezone: {
          label: 'Aikavyöhyke',
        },
      },
      toasts: {
        error: 'Aikavyöhykkeen päivittäminen epäonnistui',
      },
    },
  },
};
